/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { tableHead } from './tableHead';

import { getQuarterlyCms } from '../Store/action';

import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';

const DisplayCms = () => {
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const {
    displayObj: { quarter: getQuarter, quarterlyCms: getQuarterlyCmsList },
  } = useSelector((state) => state?.sharedState?.QuarterlyCmsReducer);

  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = useState(false);
  const [cmsData, setCmsData] = useState(false);

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  let firstInfo = '';
  useEffect(() => {
    if (getQuarterlyCmsList?.quarterlyCmsUroaReportVO?.length > 0) {
      const data = getQuarterlyCmsList?.quarterlyCmsUroaReportVO;
      const numbers = data?.filter(
        (element) => !isNaN(element.drugNameShort.trim()?.charAt(0))
      );
      const strings = data?.filter((element) =>
        isNaN(element.drugNameShort.trim()?.charAt(0))
      );
      setCmsData(
        [...strings, ...numbers]?.map((item) => {
          return {
            ...item,
            drugNameShort: item.drugNameShort?.trim(),
            unitrebateoffsetAmt: item.unitrebateoffsetAmt ? item.unitrebateoffsetAmt.toFixed(6) : 0
          };
        })
      );
    }
  }, [getQuarterlyCmsList]);

  firstInfo = `Quarter: ${getQuarter}`;
  return (
    <>
      <div className="tBillPanel custom-check">
        <div className="panel tBillPanel-space devider-line pb-0">
          <CustomSeparator
            parent1="State Reports"
            parent2="Display Quarterly CMS UROA "
          />
          <Spinner load={spinnerLoader} />
          {!fullScreenView && (
            <>
              <div className="row mb-5" />
              <div className="panel custom-fieldset">
                <div className="custom-check">
                  <div className="form-wrapper">
                    <div className="mui-custom-form input-md">
                      <div className="col-10">
                        <TextField
                          id="Quarter"
                          label="Quarter"
                          fullWidth
                          inputProps={{ id: 'Quarter' }}
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={getQuarter}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <div
            id="testGrid"
            className="panel-body FRR-custom-table tbl-manufacturer-inner"
          >
            <TableGrid
              ref={gridRef}
              data-testid="drug-type"
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              rowData={cmsData}
              columnDefs={tableHead}
              exportFile
              animateRows
              sideBar={false}
              fileName="QuarterlyCMSDrug"
              reportName="Quarterly CMS UROA Report"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressQuotesOverride
              suppressCellFocus
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              onCellFocused={onCellFocused}
              info={{ firstInfo }}
              showExportPdfOption={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DisplayCms;
